{
    "name": "St. John's Wort",
    "binomial_name": "Hypericum perforatum",
    "common_names": [
        "St. John's wort",
        "perforate St John's-wort",
        "common Saint John's wort",
        "St John's wort"
    ],
    "description": "St. John's Wort is a perennial, herbaceous to woody flowering plant native to Europe and Asia that is used as a medicinal herb to treat depression, inflammation, and wounds. Plants have erect stems with narrow, oblong leaves and yellow, star-shaped flowers. St. John's Wort will bloom the second year after planting, but can easily become invasive because it spreads through underground rhizomes and seeds. A single plant can produce 100,000 seeds that can remain viable for 10 years. Remove berries before they ripen to prevent seeds from forming. St. John's Wort should not be taken by pregnant women.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Direct seed, very lightly covering seeds. If planting indoors, harden off before transplanting seedlings outside. Can also use cuttings or divide plants.",
    "spread": 60,
    "row_spacing": 90,
    "height": 100,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/st-johns-wort.jpg",
    "icon": "/crops/icons/st-johns-wort.avif"
}